import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import es from './locales/es.json'
import ptBR from './locales/pt-BR.json'

export const SUPPORTED_LANGUAGES = ['pt-BR', 'en', 'es'] as const
export type Language = (typeof SUPPORTED_LANGUAGES)[number]

const STORAGE_KEY = 'appx-hub:language'

function detectLanguage(): Language {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    if (stored && (SUPPORTED_LANGUAGES as readonly string[]).includes(stored)) return stored as Language
  } catch {
    // Sem acesso ao storage: segue para o idioma do navegador.
  }

  const browser = navigator.language.toLowerCase()
  if (browser.startsWith('en')) return 'en'
  if (browser.startsWith('es')) return 'es'

  return 'pt-BR'
}

export function changeLanguage(language: Language): void {
  void i18n.changeLanguage(language)
  document.documentElement.lang = language
  try {
    window.localStorage.setItem(STORAGE_KEY, language)
  } catch {
    // Ignora: preferência só vale para a sessão.
  }
}

void i18n.use(initReactI18next).init({
  resources: {
    'pt-BR': { translation: ptBR },
    en: { translation: en },
    es: { translation: es },
  },
  lng: detectLanguage(),
  fallbackLng: 'pt-BR',
  interpolation: { escapeValue: false },
  returnNull: false,
})

export { i18n }
